import { createSelector } from "@reduxjs/toolkit";
import { selectWithinRadius } from "../../../map/redux/selectors/select-within-radius";

/** Returns the current map radius in miles  */
export const selectRadiusInMiles = createSelector(
	[selectWithinRadius],
	(withinRadius) => {
		var radiusInMiles = 1;
		if (withinRadius > 1000) {
			radiusInMiles = Math.ceil(withinRadius * 0.000621);
		} else {
			radiusInMiles = Math.ceil(withinRadius * 0.621);
		}

		if (radiusInMiles === 0) radiusInMiles = 1;

		return radiusInMiles;
	},
);
